import { BsFillCameraVideoFill } from "react-icons/bs";

import { SpaceObjectType } from "@graphic/types";
import styled from "styled-components";
import { useInteractObjectStore, useSpaceObjectStore } from "@graphic/stores";

function InfoElement({
  data,
  satType
}: {
  data: SpaceObjectType;
  satType: string;
}) {
  const { focus, setFocus } = useInteractObjectStore(state => ({
    focus: state.focus,
    setFocus: state.setFocus
  }));

  const find = useSpaceObjectStore(state => state.find);

  const { name, noradId } = data;
  const isFocus = focus.object?.noradId === noradId;

  const handleClick = () => {
    if (focus.object === null || focus.object.noradId !== noradId) {
      const object = find(noradId);
      if (object) {
        setFocus(object);
      }
    } else {
      setFocus(null);
    }
  };

  return (
    <ListItem
      onClick={handleClick}
      focus={isFocus ? String(isFocus) : undefined}
    >
      <h3>{`${name} \n(${noradId})`}</h3>
      <span>
        <BsFillCameraVideoFill size={20} color="#FFFFFF" />
      </span>
    </ListItem>
  );
}

const InfoList = ({
  data,
  satType
}: {
  data: SpaceObjectType[];
  satType: string;
}) => {
  return (
    <Container className="infolist">
      {data.map((sat, idx) => (
        <InfoElement
          key={`${sat.name} - ${idx}`}
          data={sat}
          satType={satType}
        />
      ))}
    </Container>
  );
};

export default InfoList;

const Container = styled.ul`
  position: absolute;
  top: 10px;
  right: 12px;
  z-index: 50;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 170px;
  cursor: pointer;
`;

const ListItem = styled.li<{ focus: string }>`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 14px;
  border: 1px solid #333;
  border-radius: 5px;
  padding: 1rem;
  background: ${({ focus }) =>
    focus ? "rgba(0, 219, 252, 0.5)" : "rgba(0, 0, 255, 0.5)"};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 12px;
  color: white;
`;
